import { Stack, Text, Image, Button } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { FLY_ANYWHERE_MAP_INDEX_ENTRY_IMAGE_URL } from "../../../../constants";
import styles from "./FlyAnywhereMapBanner.module.css";
import useCreateUrl from "../../../../hooks/useCreateUrl";
import useUserAgent from "../../../../hooks/useUserAgent";
import { useHistory, useLocation } from "react-router-dom";
import { getSearch } from "../../../../store/search/selectors";

const FlyAnywhereMapBanner = () => {
  const i18n = useI18n();
  const { createUrlWithApiPrefix } = useCreateUrl();
  const { isMobile } = useUserAgent();
  const history = useHistory();
  const location = useLocation();
  const searchState = useSelector(getSearch);

  const handleMapClick = useCallback(() => {
    const params = new URLSearchParams(location.search);

    if (!params.has("from") || !params.has("to")) {
      const segment = searchState.searchSegments?.[0];
      if (segment) {
        params.set("from", segment.from[0]?.code || "");
        params.set("to", segment.to[0]?.code || "Anywhere");
        params.set("fromCountry", segment.from[0]?.country || "");
        params.set("toCountry", "Anywhere");
        params.set("fromLocationName", segment.from[0]?.name || "");
        if (segment.departureDate) params.set("depart", segment.departureDate);
        if (segment.returnDate) params.set("return", segment.returnDate);
      }
      params.set("type", searchState.type || "ROUNDTRIP");
      params.set("adults", searchState.adults?.toString() || "1");
      params.set("cabinClass", searchState.cabinClass || "ECONOMY");
      params.set("toCountryCode", "Anywhere");
    }

    params.set("flyAnywhereView", "map");
    history.push(createUrlWithApiPrefix(`/fly-anywhere?${params.toString()}`));
  }, [history, createUrlWithApiPrefix, location.search, searchState]);

  return (
    <Stack direction="column" alignItems="start" justifyContent="start">
      <Stack.Item grow>
        <Text variant="headline_2">{i18n.trans(t("flights_cat_exploreanywhere_mapview_title"))}</Text>
      </Stack.Item>
      <div className={styles.mapImageContainer}>
        <Image
          src={FLY_ANYWHERE_MAP_INDEX_ENTRY_IMAGE_URL}
          contentMode="fill"
          borderRadius={200}
          width="100%"
          height={250}
          className={styles.mapImage}
          alt={i18n.trans(t("flights_cat_exploreanywhere_mapview_title"))}
        />
        <Button
          className={isMobile ? styles.exploreAnywhereButtonMobile : styles.exploreAnywhereButton}
          text={i18n.trans(t("flights_cat_exploreanywhere_mapview_cta"))}
          variant="elevated"
          type="button"
          size="large"
          attributes={{
            "aria-label": i18n.trans(t("flights_cat_exploreanywhere_mapview_cta"))
          }}
          onClick={handleMapClick}
        />
      </div>
    </Stack>
  );
};

export default FlyAnywhereMapBanner;
